import React, { useState, useEffect, useRef } from 'react';
import WangEditorMarkdownEditor from './WangEditorMarkdownEditor';
import { marked } from 'marked';

interface MarkdownEditorProps {
  changeCont?: (content: string) => void;
}


const MarkdownEditor = React.forwardRef((props: MarkdownEditorProps, ref) => {
  const { changeCont } = props;
  // 存储编辑后的 Markdown 内容
  const [markdownContent, setMarkdownContent] = useState(``);
  const [status, setStatus] = useState(false);
  const [keyBase, setKeyBase] = useState(1);
  const editorRef = useRef<any>(null);
  React.useImperativeHandle(ref, () => ({
    updateCont: (newValue: string, isClear?: boolean) => {
      // 通过自增 Key 彻底卸载和重建 Editor 实例，100% 规避 Slate.js 因上游选区遗留导致的 DOM 解析奔溃报错
      setKeyBase((prev) => prev + 1);
      setMarkdownContent(newValue)

    },
    getText: () => {
      return editorRef.current?.getText();
    },
    updateStatus: (newStatus: boolean) => setStatus(newStatus),
    // 暴露给父组件的方法
    MarkdownInner: (message: any, type: number, ossid?: string) => {
      // message = JSON.stringify(message)

      if (type == 0) {
        insertImgWithNewLine(message, ossid);
      } else if (type == 1) {
        insertWithNewLine(message);
      }
    },
  }));

  const handleCreated = (editor: any) => {
    editorRef.current = editor
  }

  // 内容变化时更新状态
  const handleContentChange = (newMarkdown: string) => {
    console.log(newMarkdown);

    changeCont?.(newMarkdown)
  };

  // 在光标处换行并插入自定义内容（更简单的方式）
  const insertImgWithNewLine = (message: any, ossid?: string) => {
    if (!editorRef.current) return
    console.log(editorRef.current, '插入图片');

    editorRef.current.focus();
    editorRef.current.insertBreak();
    editorRef.current.dangerouslyInsertHtml(`<img src="${message}" alt="${ossid}" href="1" data="12345532" style="2"/>`)
    editorRef.current.focus();
  }

  const insertWithNewLine = async (message: string) => {
    if (!editorRef.current) return
    editorRef.current.focus();

    try {
      const tokens = marked.lexer(message);
      const tableToken = tokens.find((t: any) => t.type === 'table');

      if (tableToken) {
        const tableNode = {
          type: 'table',
          width: 'auto',
          children: [
            {
              type: 'table-row',
              children: (tableToken as any).header.map((th: any) => ({
                type: 'table-cell',
                isHeader: true,
                colSpan: 1,
                rowSpan: 1,
                width: 'auto',
                children: [{ text: th.text }]
              }))
            },
            ...(tableToken as any).rows.map((row: any[]) => ({
              type: 'table-row',
              children: row.map((td: any) => ({
                type: 'table-cell',
                colSpan: 1,
                rowSpan: 1,
                width: 'auto',
                children: [{ text: td.text }]
              }))
            }))
          ]
        };

        editorRef.current.insertBreak();
        editorRef.current.insertNode(tableNode);
        editorRef.current.insertNode({ type: 'paragraph', children: [{ text: '' }] });
        editorRef.current.focus();
        return;
      }

      const htmlContent = await marked.parse(message);
      editorRef.current.insertBreak();
      editorRef.current.dangerouslyInsertHtml(htmlContent);
    } catch (e) {
      console.error("Failed to parse markdown", e);
      editorRef.current.insertBreak();
      editorRef.current.dangerouslyInsertHtml(message);
    }

    editorRef.current.focus();
  }



  useEffect(() => {
    return () => {

    };
  }, []);

  return (
    <div style={{ padding: '0px', margin: '0 auto' }}>
      <WangEditorMarkdownEditor
        key={`editor-${keyBase}`}
        defaultValue={markdownContent}
        onChange={handleContentChange}
        onStart={handleCreated}
        height={600}
        disabled={status} // 开启编辑
        ref={editorRef}
      />
    </div>
  );
});

export default MarkdownEditor;











